import checkout from "./form";

const {
  formField: {
    taxpayerInstead,
    taxpayerInsteadId,
    address,
    countryName,
    foreignNrganizationName,
    quarter,
    year,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    certificate,
    fullName,
    firstTime,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [taxpayerInstead.name]: "",
  [taxpayerInsteadId.name]: "",
  [address.name]: "",
  [countryName.name]: "",
  [foreignNrganizationName.name]: "",
  [quarter.name]: "",
  [year.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
